// builder-components.ts
import { Builder } from '@builder.io/react';

import CallCampaignButton from './call-campaign-button';

Builder.registerComponent(CallCampaignButton, {
  name: 'CallCampaignButton',
  noWrap: true,
});
